import React from 'react';
import { Spinner } from 'reactstrap';
import MetaTags from 'react-meta-tags';
import { Container, Row } from 'reactstrap';
import { PageWrapper } from '../pageWrapper';

export const LoadingScreen = (props) => {
  return !props.loading ? (
    <React.Fragment>{props.children}</React.Fragment>
  ) : (
    <PageWrapper title={props.titleMetaTag}>
      <Row>
        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spinner color="primary" type="grow" />
          </div>
        </div>
      </Row>
    </PageWrapper>
  );
};
